import { Text } from "./Text.mjs";
import { useTheme } from "./ThemeProvider.mjs";
import { useStyles } from "purse-styles";
import React from "react";
import { jsx } from "react/jsx-runtime";

//#region src/Link.tsx
const Link = ({ children, href, target, rel, size, color = "accent11" }) => {
	const theme = useTheme();
	return /* @__PURE__ */ jsx("a", {
		href,
		target,
		rel,
		className: useStyles({ "&:hover": {
			textDecoration: "underline",
			textDecorationColor: theme.colors[color]
		} }),
		children: /* @__PURE__ */ jsx(Text, {
			weight: "medium",
			color,
			size,
			children
		})
	});
};

//#endregion
export { Link };